__turbopack_context__.v({
  "empty": "select-module-scss-module__-71UyG__empty",
  "item": "select-module-scss-module__-71UyG__item",
  "item_indicator": "select-module-scss-module__-71UyG__item_indicator",
  "item_label": "select-module-scss-module__-71UyG__item_label",
  "search_icon": "select-module-scss-module__-71UyG__search_icon",
  "search_input": "select-module-scss-module__-71UyG__search_input",
  "search_wrapper": "select-module-scss-module__-71UyG__search_wrapper",
  "viewport": "select-module-scss-module__-71UyG__viewport",
});
